import { getLocalizedString } from '../../utils/i18n-utils';
import Link from '../common/Link';
const CONFIGURE_BROWSER_LINK = 'https://athenanet.athenahealth.com/1/1/admconfigurebrowser.esp?LOGIN=1';

export default function ConfigureBrowserLink() {
  return (
    <Link text={getLocalizedString('configure.browser.text')} href={CONFIGURE_BROWSER_LINK} id='athena-configure-browser-link' target='_blank' className='fe_u_font-size--small' />
  );
}
